<ng-container [ngSwitch]="true">
	<ng-container *ngSwitchCase="jurisdiction === 'Aams' && !plus18">
		<i
			*ngIf="isDesktop"
			class="obg-m-kyc-notification-icon"
			test-id="persistent-notification"
			[ngClass]="'ico-exclamation'"
		>
		</i>

		<label
			class="obg-m-kyc-notification-label"
			[innerHTML]="notificationData?.message | jurisdiction | translate: notificationData?.interpolateParams"
		></label>

		<a
			mat-stroked-button
			color="secondary"
			class="obg-m-kyc-notification-hyperlink aams"
			test-id="persistent-notification-button"
			*ngIf="!hideVerifyButton"
			[obgInteraction]="verifyTrackingData"
			(click)="triggerActionOrNavigate(notificationData?.destination)"
			>{{ notificationData?.linkText | jurisdiction | translate }}
		</a>

		<span
			class="obg-m-kyc-notification-close ico-close-2"
			test-id="obg-m-kyc-notification-close"
			(click)="close.emit()"
		></span>
	</ng-container>

	<ng-container *ngSwitchCase="jurisdiction === 'COGA'">
		<i
			class="obg-m-kyc-notification-icon"
			test-id="persistent-notification"
			[ngClass]="plus18 ? 'ico-over18' : 'ico-exclamation-light'"
		></i>

		<label
			class="obg-m-kyc-notification-label"
			[innerHTML]="notificationData?.message | jurisdiction | translate: notificationData?.interpolateParams"
		>
		</label>

		<a
			class="obg-m-kyc-notification-button"
			test-id="persistent-notification-button"
			*ngIf="!hideVerifyButton"
			[obgInteraction]="verifyTrackingData"
			(click)="triggerActionOrNavigate(notificationData?.destination)"
			>{{ notificationData?.linkText | jurisdiction | translate }}
		</a>
	</ng-container>

	<ng-container *ngSwitchDefault>
		<i
			class="obg-m-kyc-notification-icon"
			test-id="persistent-notification"
			[ngClass]="plus18 ? 'ico-over18' : 'ico-exclamation'"
		>
		</i>

		<label
			class="obg-m-kyc-notification-label"
			[innerHTML]="notificationData?.message | jurisdiction | translate: notificationData?.interpolateParams"
		></label>

		<a
			class="obg-m-kyc-notification-hyperlink mat-stroked-button"
			test-id="persistent-notification-button"
			*ngIf="!hideVerifyButton"
			[obgInteraction]="verifyTrackingData"
			(click)="triggerActionOrNavigate(notificationData?.destination)"
			>{{ notificationData?.linkText | jurisdiction | translate }}
		</a>
	</ng-container>
</ng-container>
